<script>
import { mapGetters } from "vuex";

export default {
  name: "Bahn1VideoTeaser",
  computed: {
    ...mapGetters("bahn1", ["teaserVid"]),
    videoUrl() {
      const media = this.teaserVid && this.teaserVid.TeaserVid;
      return media ? this.$store.getters.getStrapiDocumentUrl(media) : null;
    }
  }
};
</script>

<template>
  <div class="video-teaser" v-if="teaserVid && teaserVid.TeaserVid">
    <div class="video-teaser-media">
      <video
        class="teaser-video-player"
        :src="videoUrl"
        controls
        preload="metadata"
      ></video>
    </div>
    <div class="video-teaser-body">
      <span class="video-teaser-label">VIDEO TEASER</span>
      <div class="video-teaser-title">{{ teaserVid.Titel }}</div>
      <div class="video-teaser-duration">{{ teaserVid.Dauer }}</div>
    </div>
  </div>
</template>

<style scoped>
.video-teaser {
  width: 100%;
  aspect-ratio: 100 / 36.5;
  background: #004ba0;
  color: #ffffff;
  display: flex;
  margin-bottom: 56px;
}
.video-teaser-media {
  flex: 0 0 50%;
  box-sizing: border-box;
  padding: 24px;
  height: 100%;
}
.teaser-video-player {
  width: auto;
  max-width: 100%;
  margin: 0 auto;
  height: 100%;
  object-fit: contain;
  display: block;
  background: transparent;
}
.video-teaser-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px 40px;
}
.video-teaser-label {
  align-self: flex-start;
  background: #ffffff;
  color: #000000;
  border-radius: 4px;
  padding: 3px 6px 3px 6px;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.6px;
}
.video-teaser-title {
  font-size: 30px;
  margin-top: 8px;
}
.video-teaser-duration {
  font-size: 14px;
  line-height: 1;
  margin-top: 8px;
}
@media (max-width: 959px) {
  .video-teaser {
    aspect-ratio: auto;
    flex-direction: column;
  }
  .video-teaser-media {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
  }
  .teaser-video-player {
    height: auto;
    width: auto;
    max-width: 100%;
    max-height: 70vh;
  }
  .video-teaser-body {
    width: 100%;
  }
}
@media (max-width: 599px) {
  .video-teaser-body {
    padding: 24px;
  }
}
</style>
